import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'calsoft-comparison',
  templateUrl: './comparison.component.html',
  styleUrls: ['./comparison.component.scss']
})
export class ComparisonComponent implements OnInit {
  @Input() data : any ;
  @Input() img: any;

  @Input() item: any;

  leftArray: any[] = [];
  rightArray: any[] = [];

  ngOnInit(): void {
    const leftSize = this.item?.customField39 || 3;
    const rightSize = this.item?.customField40 || 2;


    

    this.leftArray = this.img.slice(0, leftSize);
    
    this.rightArray = this.img.slice(leftSize, leftSize + rightSize);
}
}